import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import t from 'rcm-i18n';
import { AddToCartPopupContainer } from 'block-multi-add-to-cart-client';
import type { ProductData } from './types';
import { GtagCartUpdateMethod } from 'google-analytics';
import classNames from 'classnames';

interface Props {
  product: ProductData;
  showAddToCartButton: boolean;
  productIndex: string;
}

const Product = ({ product, showAddToCartButton, productIndex }: Props) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const toolTipParentRef = useRef<HTMLImageElement>(null);

  const handleOnContinueShopping = useCallback(() => {
    setPopupOpen(false);
  }, []);

  const handleAddToCart = useCallback(() => {
    setPopupOpen(true);
  }, []);

  const productName = product.name;

  // if (Math.random() < .3) { productName = 'Test Long Name Shaker Reliv sport édition limitée' }; //Uncomment to test long names
  useLayoutEffect(() => {
    // Enable faster better looking Bootstrap 3 tool tips
    if (product.tooltip) {
      jQuery(toolTipParentRef.current).tooltip();
    }
  }, [product.tooltip]);

  return (
    <div
      className='all-products-product col-lg-3 col-md-4 col-xs-12'
      data-debug-product-id={product.productId}
    >
      <a href={product.detailPageUrl} className='all-products-product-link'>
        <img
          className='all-products-product-image'
          src={product.image}
          ref={toolTipParentRef}
          data-toggle='tooltip' // Bootstrap 3
          data-placement='bottom' // Bootstrap 3
          title={product.tooltip}
        />
        <div
          className='all-products-product-name all-products-product-name-one-line-high'
          title={productName}
        >
          {productName}
        </div>
      </a>
      <div>
        <div className='all-products-product-price'>
          {t('Retail')}: {product.price}
        </div>
        {showAddToCartButton && (
          <div>
            <AddToCartPopupContainer
              productId={product.productId.toString()}
              skuOptions={product.skuOptions}
              isOpen={popupOpen}
              onContinueShopping={handleOnContinueShopping}
              cart_update_method={GtagCartUpdateMethod.ALL_PRODUCTS_CATALOG}
              productIndex={productIndex}
            />
            <a
              id={`add-to-cart-button-${productIndex}`}
              onClick={handleAddToCart}
              className={classNames(
                'all-products-product-button',
                'btn',
                'btn-primary',
                'add-to-cart-button'
              )}
            >
              {t('Add to Cart')}
            </a>
          </div>
        )}
      </div>
      <div className='all-products-border-bottom' />
    </div>
  );
};

export default Product;
